import { Paper } from '@flippingbook/web.react-kit/dist/Paper';

import { b, e } from '../Login/style.css';

export function MessagePage({ message }: StatusMessage.Props) {
    return (
        <div className={b.name}>
            <div className={e.container}>
                <Paper
                    className={e.card}
                    radius="large"
                >
                    <p className={e.restoreMessage}>{message}</p>
                </Paper>
            </div>
        </div>
    );
}

namespace StatusMessage {
    export interface Props {
        message: React.ReactNode;
    }
}
